export default __webpack_public_path__ + "static/media/CapaLogoBetaWhiteKo.4a03d66a.svg";